import { render, staticRenderFns } from "./singleAdministrationChildrenThreeEdit.vue?vue&type=template&id=13fbf492"
import script from "./singleAdministrationChildrenThreeEdit.vue?vue&type=script&lang=js"
export * from "./singleAdministrationChildrenThreeEdit.vue?vue&type=script&lang=js"
import style0 from "./singleAdministrationChildrenThreeEdit.vue?vue&type=style&index=0&id=13fbf492&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports